import useSWR from 'swr';

export const useEmailRecommend = query => {
  const { data: emailList } = useSWR(
    query ? `/api/v2/outbound_message/email_search?query=${query}` : null
  );
  return emailList || [];
};
